<template>
  <v-dialog :value="value" persistent width="900" @click:outside="close()">
    <v-card>
      <v-card-title class="pl-6 pr-2 pt-4 pb-0">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        <div class="title h6">
          Missing Linked Items Warning
        </div>
      </v-card-title>
      <v-container fluid class="pa-0">
        <div class="mx-6 my-4">
          At least one linked item is missing. Please review before proceeding.
        </div>
        <div class="mx-6 my-4">
          {{ 'Incomplete Linked Group(s): ' + missingLinkedGroupIds.join(", ") }}
        </div>
        <v-data-table
          :loading="loading"
          :items="missingLinkedItems"
          :headers="headers"
          class="mx-4"
          no-data-text="No missing linked items"
          dense
          fixed-header
          disable-pagination
          hide-default-footer
          :items-per-page="-1"
          :height="tableHeight">
          <template #[`item.sale_price`]="{ item }">
            <span v-if="item.sale_price">${{$config.formatCurrency(item.sale_price)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.pack_size`]="{ item }">
            <span v-if="item.pack_size">{{item.pack_size}}</span>
            <span v-else>-</span>
          </template>
        </v-data-table>
        <div class="mt-4 d-flex justify-center">
          <v-btn class="mb-4 mr-4" text @click="close()">
            Cancel
          </v-btn>
          <v-btn class="mb-4" color="warning" @click="confirm()">
            Confirm
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import ItemGroup from '@/axios/item-group-endpoint'
import { utils } from '@/mixins/utils'
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'MissingLinkedItemsAlertModal',
  mixins: [displayAlert, utils],
  props: [
    'value',
    'missingItems'
  ],
  data() {
    return {
      loading: false,
      missingLinkedItems: [],
      missingLinkedGroups: [],
      missingLinkedGroupIds: [],
      headerProps: {
        sortable: false,
        class: 'accent white--text'
      },
      baseHeaders: [
        { text: 'Linked Group', value: 'linked_group' },
        { text: 'Item ID', value: 'item_id' },
        { text: 'Source', value: 'source' },
        { text: 'Description', value: 'description' },
        { text: 'Retail Price', value: 'sale_price' },
        { text: 'Size', value: 'pack_size' }
      ]
    }
  },
  async created() {
    this.missingLinkedGroupIds  = [...new Set(this.missingItems.map(item => item.linked_group))]
    await this.getItems()
  },
  methods: {
    async getItems () {
      this.loading = true
      const itemsToGetGroups = []
      for (const group_id of this.missingLinkedGroupIds) {
        const item = this.missingItems.find(item => group_id === item.linked_group)
        itemsToGetGroups.push(item)
      }
      try {
        let itemGroupPromises = []
        for (const item of itemsToGetGroups) {
          itemGroupPromises.push(this.getItemGroups(item))
        }
        await Promise.all(itemGroupPromises)
        let groupItems = []
        for (const group of this.missingLinkedGroups) {
          for await (let results of ItemGroup.getGroupItems(group.id)){
            groupItems = groupItems.concat(results)
          }
        }
        groupItems = groupItems.map(gi => gi.item)
        this.missingLinkedItems = this.missingItems.map(item => {
          const groupItem = groupItems.find(gi => gi.item_id === item.item_id)
          return {
            ...item, 
            ...groupItem,
            source: this.$store.getters.getSourceName(item.source)
          }
        })
        this.missingLinkedItems = this.sortByKey(this.missingLinkedItems, 'item_id')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async getItemGroups (item) {
      try {
        const res = await ItemGroup.getGroupsByItem(item.source, item.item_id)
        if (res?.data?.length > 0 && !this.missingLinkedGroups.find(group => group.linked_group === res?.data[0].linked_group)) {
          this.missingLinkedGroups = this.missingLinkedGroups.concat(res?.data[0])
        }
      } catch (err) {
        this.handleError(err)
      }
    },
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('submitWithMissingLinkedItemsAlert')
    }
  },
  computed: {
    headers () {
      return this.baseHeaders.map(header => {
        return { ...this.headerProps, ...header }
      })
    },
    tableHeight() {
      return this.missingItems.length <= 3 ? '135px' : this.missingItems.length <= 7 ? '315px' : '450px'
    }
  }
}
</script>
<style>
.title {
  width: 67%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>